export default __webpack_public_path__ + "static/privateClass-e5742a4dfc8341f459d0facfef8c6619.png";